import { useState } from 'react';
import { subscribeNewsletter } from '../api/newsletter';

export function RegisterPage() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [email, setEmail] = useState('');
  const [checked, setChecked] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMsg('*Please enter a valid email address.');
      return;
    }

    setIsLoading(true);
    try {
      await subscribeNewsletter(email);
      setIsSuccess(true);
    } catch (err) {
      setErrorMsg(err instanceof Error ? err.message : 'Registration failed.');
    } finally {
      setIsLoading(false);
    }
  };

  const isSubmitDisabled = !email || !checked || isLoading;

  if (isSuccess) {
    return (
      <div className="main-container" id="subscription_confirm">
        <div className="main-container-top">
          <h2>Email Address Confirmation</h2>
          <p className="main-text">
            A subscription confirmation email has been sent. Please check your email.
          </p>
          <p className="note-text">
            Emails will be sent from info@newsletter.mangamillion.shueisha.co.jp.
            <br />
            If you do not receive an email, please check your spam or junk folder and add this
            address to your safe sender list if necessary.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container" id="subscription_form">
      <div className="main-container-top">
        <h2>Newsletter Subscription Form</h2>
        <p className="main-text">
          Please enter the email address where the newsletter should be sent and click the
          &quot;Subscribe&quot; button.
        </p>
      </div>
      <form className="form-fields" onSubmit={handleSubmit}>
        <div className="email-input">
          <label htmlFor="subscribeEmail">email</label>
          <input
            type="email"
            id="subscribeEmail"
            placeholder="Please input"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrorMsg('');
            }}
            required
          />
          {errorMsg && <p className="error-text">{errorMsg}</p>}
        </div>
        <label className="email-checkbox" htmlFor="ageVerification">
          <input
            type="checkbox"
            id="ageVerification"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <span className="main-text">I am 16 years of age or older.</span>
        </label>
        <button className="primary" type="submit" id="form-subscribe" disabled={isSubmitDisabled}>
          <span />
          <span>{isLoading ? 'Sending...' : 'Subscribe'}</span>
          <img src="/assets/arrow_right_white.svg" alt="" width="24" height="24" />
        </button>
      </form>
    </div>
  );
}
